export default "__VITE_ASSET__CAFDDdgI__"